<template>
  <div>
    <b-card title="My Refund History">
      <!-- search input -->
      <b-row v-if="hasData" class="mb-1">
        <b-col>
          <b-form-group>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="search"
            />
          </b-form-group>
        </b-col>
        <b-col />
        <b-col class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Action -->
          <!-- <span v-if="props.column.field === 'action'">
            <span v-if="user.userId !== props.row.id">
              <b-row v-if="props.row.paymentStatus !== 3"> -->
          <!-- v-else-if="props.row.Payment_Status==='pending'" -->
          <!-- <b-dropdown
                  variant="link"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>

                  <b-dropdown-item
                    href="#"
                    :to="{
                      name: 'refund-handler',
                      params: { id: props.row.id },
                    }"
                    variant="info"
                  >
                    <feather-icon class="yellow-icon" icon="ActivityIcon" />
                    <span class="align-middle ml-50">Handle</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
            </span>
          </span> -->

          <span v-if="props.column.field === 'actionDescription'">
            <span>
              <b-badge
                v-if="props.row.actionDescription === 'Approved'"
                pill
                variant="success"
                class="text-light"
              >
                {{ props.row.actionDescription }}
              </b-badge>

              <b-badge
                v-else-if="props.row.actionDescription === 'Rejected'"
                pill
                variant="danger"
                class="text-light"
              >
                {{ props.row.actionDescription }}
              </b-badge>
            </span>
          </span>
          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";

export default {
  name: "Users",
  components: {
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      hasData: false,
      rows: [],
      pageLength: 5,
      columns: [
        {
          label: "Refund Initiated Date",
          field: "refundRequestedDate",
        },
        {
          label: "First Name",
          field: "firstName",
        },
        {
          label: "Last Name",
          field: "lastName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Order Id",
          field: "orderId",
        },
        {
          label: "Refund Reference Code",
          field: "refundReferenceCode",
        },
        {
          label: "Refund Merchant Request Code",
          field: "refundMerchantRequestCode",
        },
        {
          label: "Paid FOP",
          field: "paidPaymentOptionName",
        },
        {
          label: "Vendor TxnRef. Number",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Original Ticket Number",
          field: "originalTicketNumber",
        },
        {
          label: "Refund Requested Amount",
          field: "refundRequestedAmount",
        },
        {
          label: "Status",
          field: "actionDescription",
        },
        {
          label: "Remark",
          field: "remark",
        },
      ],
      statusOptions: [
        { value: "0", text: "All" },
        { value: "1", text: "Pending" },
        { value: "2", text: "Approved" },
        { value: "3", text: "Canceled" },
      ],
      searchTerm: "",
      sheets: [{ name: "Detail Refund Requests", data: [] }],
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch("config/getActionPrivilege", "Refund-History");
      this.isLoading = true;
      axios
        .get("/Order/api/V1.0/Refund/GetRefundActionHistory")
        .then((res) => {
          this.sheets[0].data = [];
          this.hasData = true;
          this.rows = res.orders;
          res.orders.map((m) => {
            this.sheets[0].data.push({
              "Refund Requested Date": m.refundRequestedDate,
              "First Name": m.firstName,
              "Last Name": m.lastName,
              Email: m.email,
              "Custom Order Code": m.customOrderCode,
              OrderId: m.orderId,
              "Refund Reference Code": m.refundReferenceCode,
              "Paid FOP": m.paidPaymentOptionName,
              "Vendor TxnRef. Number": m.vendorTxnRefNumber,
              "Refund Requested Amount": m.refundRequestedAmount,
              "Paid Date": m.paidDate,
              "Paid Account Number": m.paidAccountNumber,
              "Original Ticket Number": m.originalTicketNumber,
              "Refund Account Number": m.refundAccountNumber,
              "Refund Status":
                m.refundStatus == 0
                  ? "Refund Not Requested"
                  : m.refundStatus == 1
                  ? "Refund Pending"
                  : m.refundStatus == 2
                  ? "Refund Submitted"
                  : m.refundStatus == 3
                  ? "Refund Approved"
                  : m.refundStatus == 4
                  ? "Refund Sent"
                  : m.refundStatus == 5
                  ? "Refund Rejected"
                  : m.refundStatus == 6
                  ? "Refund Completed"
                  : null,
              Remark: m.remark,
            });
          });
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
